import React from "react";

export const EmptyRecord = ({message}) => (
    <div style={{textAlign: 'center'}}>
        <p><i className="fa fa-info-circle fa-2x"></i></p>
        <p>{message}</p>
    </div>
);